import React from 'react';
import styled from '@emotion/styled';

import ArrowIcon, { arrowIconStyles } from './ArrowIcon';
import type { ControlButtonProps } from './ControlButton';
import { ControlButton, controlButtonStyles } from './ControlButton';

const NextControlButton = styled(ControlButton)``;

const NextControl = ({ disabled, handleClick }: ControlButtonProps) => (
  <NextControlButton
    {...controlButtonStyles}
    aria-disabled={disabled}
    onClick={handleClick}
    data-testid="carousel-next-button"
    aria-hidden={true}
    disabled={disabled}
  >
    <ArrowIcon
      {...arrowIconStyles}
      stroke={disabled ? 'sys.neutral.icon.inactive' : 'sys.neutral.icon.default'}
    />
  </NextControlButton>
);

export default NextControl;
